import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-register-org',
  templateUrl: './register-org.component.html',
  styleUrls: ['./register-org.component.scss']
})
export class RegisterOrgComponent implements OnInit {

  isProcessing: boolean = false;
  targetShortName: any = "";
  resultMsg: any = "";
  searchValue1: any = "";
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  perPage3 = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private users: any[];
  pager: any = {};
  pager3: any = {};
  pagedItems: any[]; pagedItems1: any[];
  pagedItems2: any[];
  pagedItems3: any[];

  @ViewChild('viewOrgspopup', { static: true }) viewOrgspopup: TemplateRef<any>;
  @ViewChild('confirmationPopup', { static: true }) confirmationPopup: TemplateRef<any>;
  visibleViewOrgsPopup: MatDialogRef<TemplateRef<any>>;
  visibleConfimartionPopup: MatDialogRef<TemplateRef<any>>;

  viewOrgsPopupConfig = {
    width: '1000px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  confimationPopupConfig = {
    width: '700px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  constructor(public dialog: MatDialog, private appService: AppService, public router: Router, private snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService) {

  }

  ngOnInit(): void {

  }

  resultType: any = "";
  registerOrgFunc() {
    this.isProcessing = true;
    this.resultMsg = "";
    this.resultType = "";
    let obj = {
      targetOrgShortName: this.targetShortName
    }
    this.appService.registerOrganization(obj).subscribe((data: any) => {
      if (data.resultType == "E") {
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok",

          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      } else {
        this.resultMsg = data.result;
        this.resultType = "S";
        this.isProcessing = false;
        this.visibleConfimartionPopup = this.dialog.open(this.confirmationPopup, this.confimationPopupConfig);
      }

    })

  }

  organizationsList: any = [];
  viewOrgsFunc() {
    this.organizationsList = [];
    this.isProcessing = true;
    this.appService.getOrgs().subscribe((data: any) => {
      this.organizationsList = data;
      this.isProcessing = false;
      this.collectionSize = this.organizationsList.length;
      this.pager.totalPages = undefined;
      this.setPage1(1, 0);
      this.visibleViewOrgsPopup = this.dialog.open(this.viewOrgspopup, this.viewOrgsPopupConfig);
    })

  }

  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.organizationsList.length, page, this.perPage, targetpage);
    this.pagedItems1 = this.organizationsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }

  viewOrgConfirmation() {
    this.visibleViewOrgsPopup.close();
  }

  okForConfirmation() {
    this.visibleConfimartionPopup.close();
  }

}
